var map = {
	"./activity.png": "38e8",
	"./cause_risk.png": "b4f7",
	"./coping_and_living.png": "3338",
	"./diagnosis.png": "7a22",
	"./lifestyle.png": "c39b",
	"./medication.png": "b920",
	"./symptom.png": "3508",
	"./vital.png": "06d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ee7";